// src/pages/tw/Terms_tw.js
import React from "react";
import { Link } from "react-router-dom";
import "../Terms.css";

function Terms() {
  return (
    <div className="terms-page" lang="zh-Hant">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/tw" className="brand-link" aria-label="返回繁體中文首頁">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="terms-title">
        <article className="generator-card terms-card" aria-labelledby="terms-title">
          <header className="terms-header">
            <h1 id="terms-title" className="card-title">TooLoves.net 服務條款</h1>
            <p className="card-subtitle terms-updated">
              最後更新：
              <time dateTime="2025-10-22"> 2025年10月22日（KST）</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              本服務條款（下稱「本條款」）係由 TooLoves.net 之營運者（下稱「營運者」）就其所經營之網站
              TooLoves.net（下稱「本網站」）之使用，規範會員與訪客（合稱「使用者」）應遵守之權利、義務與責任事項。
              使用本網站即視為同意本條款。
            </p>
          </section>

          <section className="terms-section" id="purpose">
            <h2 className="section-title">1. 使用目的</h2>
            <p>
              TooLoves.net 提供 QR 碼產生器、影像浮水印、AI 相片 EXIF 擷取等多項線上工具，
              協助使用者快速且便利地完成數位作業。
            </p>
          </section>

          <section className="terms-section" id="user-duties">
            <h2 className="section-title">2. 使用者義務</h2>
            <ol>
              <li>使用者於使用本網站時，應遵守相關法令及本條款。</li>
              <li>不得濫用網站功能，或以違法、危害之目的使用本網站。</li>
              <li>禁止侵害他人權利（包括著作權、肖像權、個人資料等）。</li>
              <li>
                嚴禁以下行為：
                逆向工程、繞過或規避技術措施、自動化資料蒐集、干擾服務、
                安全性侵害、散布惡意程式、發布違法資訊、冒用他人身分、
                以過量請求造成系統過載等。
              </li>
            </ol>
          </section>

          <section className="terms-section" id="service-changes">
            <h2 className="section-title">3. 服務提供與變更</h2>
            <ol>
              <li>為維持本網站之穩定運作，營運者得視需要變更、中斷或終止服務。</li>
              <li>變更後如使用者仍繼續使用服務，視為已同意變更後之條款。</li>
              <li>
                若使用者違反本條款或相關法令，或基於網站營運之需要，
                營運者得不經另行同意或通知，限制或阻斷使用者之服務存取。
              </li>
            </ol>
          </section>

          <section className="terms-section" id="copyright">
            <h2 className="section-title">4. 著作權</h2>
            <ol>
              <li>本網站所刊載之所有內容（文字、圖片、程式碼等）之著作權，均由營運者享有。</li>
              <li>
                使用者透過本服務所生成、上傳、傳送或提供予他人之所有資訊與內容（下稱「使用者產生內容」）之著作權，屬於該使用者。
              </li>
              <li>
                使用者僅得於個人、非商業目的使用內容；除使用網站內建之分享按鈕外，不得以其他方式散布。
              </li>
            </ol>
          </section>

          <section className="terms-section" id="liability">
            <h2 className="section-title">5. 責任限制</h2>
            <ol>
              <li>營運者不保證使用者透過本網站生成之資料之正確性、完整性、安全性或無害性。</li>
              <li>因使用本網站所生之損害，在法令允許之範圍內，營運者不負任何責任。</li>
              <li>關於使用者產生內容所致之民、刑事責任，悉由該使用者自行承擔，營運者不負任何責任。</li>
            </ol>
          </section>

          <section className="terms-section" id="privacy">
            <h2 className="section-title">6. 個人資料保護</h2>
            <p>
              本網站使用過程中所蒐集之個人資料，將依{" "}
              <Link to="/tw/privacy" className="link" aria-label="查看隱私權政策">隱私權政策</Link>
              之規定予以安全處理。
            </p>
          </section>

          <section className="terms-section" id="changes">
            <h2 className="section-title">7. 條款之變更</h2>
            <p>營運者得視需要修訂本條款；變更後之內容將透過網站公告或通知方式告知。</p>
            <p>使用者於變更後仍繼續使用本網站者，視為同意變更後之條款。</p>
          </section>

          <section className="terms-section" id="disputes">
            <h2 className="section-title">8. 爭議解決</h2>
            <p>
              本條款及服務相關之爭議，以大韓民國法律為準據法，
              並以營運者居住地所屬之管轄法院為第一審管轄法院。
            </p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">9. 聯絡方式</h2>
            <p>
              服務相關問題，請聯繫{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="寄送電子郵件至 helptooloves@gmail.com"
              >
                helptooloves@gmail.com
              </a>
              。
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/tw" className="btn" aria-label="返回繁體中文首頁">
              返回繁體中文首頁
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">© 2025 TooLoves. All rights reserved.</footer>
    </div>
  );
}

export default Terms;